import { AuditLogInfo } from './audit-logs.interface'
import { getAuditLogInfoState, getAuditLogsState } from './audit-logs.selectors'
import ListTrait from 'src/app/traits/list.trait'
import {
  SetDefaultData,
  UpdateField,
  FetchAuditLogsRequest,
  FetchAuditLogInfoRequest,
} from './audit-logs.actions'
import { Router, ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnChanges, OnDestroy } from '@angular/core'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'
import { TranslateService } from '@ngx-translate/core'
import { formatDate } from '@angular/common'
import { filtersToDbQuery, toDate } from '@shared/shared.utils'
import { TableFilterType } from '@shared/shared.types'
import { getAuditLogTypesState } from '@shared/shared.select'
import { FetchAuditLogTypesRequest } from '@shared/shared.actions'

@Component({
  selector: 'app-audit-logs',
  templateUrl: './audit-logs.component.html',
  styleUrls: ['./audit-logs.component.css'],
})
export class AuditLogsComponent extends ListTrait implements OnInit, OnDestroy {
  private state$: Subscription
  private info$: Subscription
  public info: Map<string, any>
  private route$: Subscription
  private shouldReload: boolean
  public isLoading: boolean
  public isInfoLoading: boolean
  public isInfoModalOpen: boolean
  public columns: object[] = [
    {
      prop: 'actor',
      name: 'ACTOR',
      sortable: true,
      filterable: true,
      filterKey: 'actor.fullName',
      filterType: TableFilterType.String,
      render: (column: Map<string, any>) => {
        return `${column.get('firstName')} ${column.get('lastName')}`
      },
    },
    {
      prop: 'objectType',
      name: 'OBJECT_TYPE',
      sortable: true,
      filterType: TableFilterType.String,
      filterable: true,
      template: 'objectType',
      select$: null, // Will be set in ngOnInit
    },
    {
      prop: 'objectLabel',
      name: 'OBJECT_LABEL',
      sortable: true,
      filterable: true,
      filterType: TableFilterType.String,
    },
    {
      prop: 'note',
      name: 'NOTE',
      sortable: true,
      filterable: true,
      filterType: TableFilterType.String,
    },
    {
      prop: 'createdAt',
      name: 'CREATED_AT',
      sortable: true,
      template: 'createdAtColumn',
      filterable: true,
      filterType: TableFilterType.Date,
    },
    {
      prop: 'info',
      name: '',
      sortable: false,
      template: 'infoColumn',
    },
  ]
  public filters: any[]

  constructor(
    private store: Store<any>,
    public router: Router,
    private route: ActivatedRoute,
    public translateService: TranslateService,
  ) {
    super(router)
  }

  toggleInfoModal(id?: number) {
    if (!this.isInfoModalOpen && id) {
      this.store.dispatch<any>(new FetchAuditLogInfoRequest(id))
    }

    this.isInfoModalOpen = !this.isInfoModalOpen
  }

  ngOnInit() {
    // Set the select$ property after store is initialized
    (this.columns[1] as any).select$ = this.store.pipe(select(getAuditLogTypesState))
    
    this.store.dispatch<any>(new SetDefaultData('list'))
    this.state$ = this.store
      .pipe(select(getAuditLogsState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
        this.filters = state.get('filters').toJS()

        if (
          state.get('shouldReload') !== this.shouldReload &&
          state.get('shouldReload')
        ) {
          this.runFilter()
        }
        this.shouldReload = state.get('shouldReload')
      })

    this.info$ = this.store
      .pipe(select(getAuditLogInfoState))
      .subscribe((state) => {
        this.info = state.get('data')
        this.isInfoLoading = state.get('isLoading')
      })

    this.runFilter()
    this.store.dispatch<any>(new FetchAuditLogTypesRequest())
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.info$.unsubscribe()
  }

  runFilter(data?: any) {
    const filters = data?.filters ?? this.filters
    const pagination = data?.pagination ?? this.state.get('pagination').toJS()
    const { page, page_size, sort, order_by } = pagination

    this.store.dispatch<any>(
      new FetchAuditLogsRequest({
        filters: {
          ...filtersToDbQuery(filters),
        },
        pageSize: parseInt(page_size, 10),
        page: parseInt(page, 10) - 1,
        sort: {
          order: sort?.toUpperCase(),
          prop: order_by,
        },
      }),
    )

    this.store.dispatch(new UpdateField('filters', filters, 'list'))
    this.store.dispatch(new UpdateField('pagination', pagination, 'list'))
  }
}
